export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    let iconSlot = this.buildIconSlot()
    let ctaSlot = this.buildCtaSlot()
    let textSlot = this.buildTextSlot()
    return `
      <wfs-banner
        id="${this.ids.id}"
        classes="${this.classes.classes}"
        ${this.content.isClosable ? 'isClosable' : ''}
        ${this.content.hasIcon ? 'hasIcon' : ''}
        ${this.content.hasCTA ? 'hasCTA' : ''}
      >
        ${iconSlot}
        ${ctaSlot}
        ${textSlot}
      </wfs-banner>`
    }

  buildIconSlot() {
    if (! this.content.hasIcon) {
      return ''
    }
    return `<template v-slot:icon>
      <div
        id="${this.ids.iconContainerId}"
        class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center ${this.classes.iconContainerClasses}"
      >
        <i id="${this.ids.iconId}" class="${this.content.class} ${this.content.icon}"></i>
      </div>
    </template>`
  }

  buildCtaSlot() {
    if (! this.content.hasCTA) {
      return ''
    }
    return  `<template v-slot:cta>
      <a
        id="${this.ids.ctaId}"
        href="${this.content.ctaLink}"
        class="wf-items-center wf-flex wf-justify-center wf-leading-none focus:wf-outline-none wf-font-bold wf-text-sm wf-tracking-wide wf-px-4 wf-h-10 wf-inline-block ${this.classes.ctaClasses}"
      >${this.content.ctaText}</a>
    </template>`
  }

  buildTextSlot() {
    return `<template v-slot:text>
      <p id="${this.ids.textId}">${this.content.text}</p>
    </template>`
  }
}